class AppConfig {
  constructor() {
    console.log("App config ENV Value :  --->", process.env.NODE_ENV);
  }

  getBaseUrl(): string {
    // Use development URL if NODE_ENV is development, otherwise use production
    const baseUrl = process.env.NODE_ENV === 'production'
      ? (process.env.REACT_APP_BASE_URL_DEV || "https://www.httaxsolutions.com/api")
      : (process.env.REACT_APP_BASE_URL_PROD || "https://www.httaxsolutions.com/api");
    
    console.log("App config baseUrl --->", baseUrl);
    console.log("Current hostname:", window.location.hostname);
    return baseUrl;
  }

  getLocalURL(): string {
    // Use development URL if NODE_ENV is development, otherwise use production
    return process.env.NODE_ENV === 'production'
      ? "https://www.httaxsolutions.com"
      : (process.env.REACT_APP_BASE_URL_PROD || "https://www.httaxsolutions.com");
  }

  googleLogin(): string {
    return `${this.getBaseUrl()}oauth2/authorization/google?redirect_uri=${this.getLocalURL()}`;
  }
}

const appConfig = new AppConfig();

export default appConfig;
